import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './BlogPage.css';

const CATEGORIES = ['All', 'WhatsApp', 'E-Commerce', 'AI & Automation', 'Sales', 'Product Updates'];

const POSTS = [
  {
    slug: 'whatsapp-business-api-vs-app',
    category: 'WhatsApp',
    title: 'WhatsApp Business API vs WhatsApp Business App: Which One Does Your Business Need? (2026)',
    excerpt: 'They share a name but solve different problems. The free app is a better inbox for one person. The API is infrastructure for a team. Here is exactly where the app stops working — and how to tell which side of that line you are on.',
    readTime: '9 min read',
    date: 'Jul 14, 2026',
    featured: false,
    image: '/blog/WhatsApp Business API vs WhatsApp Business App Which One Does Your Business Need (2026).png',
    imageAlt: 'WhatsApp Business API vs WhatsApp Business App: side-by-side comparison for 2026',
  },
  {
    slug: 'whatsapp-message-sequence',
    category: 'WhatsApp',
    title: 'WhatsApp Message Sequence: How to Build Multi-Step Automation That Converts (2026)',
    excerpt: 'A WhatsApp message sequence automates multi-step conversations — from welcome to purchase — without manual work. Learn how to design, build, and optimize sequences that engage leads at every stage.',
    readTime: '8 min read',
    date: 'Jul 9, 2026',
    featured: false,
    image: '/blog/WhatsApp Message Sequence How to Build Multi-Step Automation That Converts (2026).png',
    imageAlt: 'WhatsApp Message Sequence: Build Multi-Step Automation That Converts 2026',
  },
  {
    slug: 'whatsapp-sales-funnel',
    category: 'Sales',
    title: 'WhatsApp Sales Funnel: How to Build a High-Converting Pipeline (2026 Guide)',
    excerpt: 'A WhatsApp sales funnel moves leads from first contact to closed deal — automatically. Learn how to build a full-funnel strategy with entry points, nurture sequences, and conversion flows.',
    readTime: '8 min read',
    date: 'Jul 8, 2026',
    featured: false,
    image: '/blog/WhatsApp Sales Funnel How to Build a High-Converting Pipeline (2026 Guide).png',
    imageAlt: 'WhatsApp Sales Funnel: Build a High-Converting Pipeline 2026',
  },
  {
    slug: 'whatsapp-follow-up-message',
    category: 'WhatsApp',
    title: 'WhatsApp Follow-Up Message: 15 Templates That Get Replies (2026)',
    excerpt: 'Most leads do not convert on first contact. A well-timed WhatsApp follow-up message is the difference between a lost lead and a closed deal. Use these 15 proven templates to get more replies without being pushy.',
    readTime: '9 min read',
    date: 'Jul 7, 2026',
    featured: false,
    image: '/blog/WhatsApp Follow-Up Message 15 Templates That Get Replies (2026).png',
    imageAlt: 'WhatsApp Follow-Up Message: 15 Templates That Get Replies 2026',
  },
  {
    slug: 'whatsapp-automation-guide',
    category: 'WhatsApp',
    title: 'The Ultimate Guide to WhatsApp Automation for Business (2026)',
    excerpt: 'Everything you need to know about WhatsApp automation — what it is, how it works, which workflows deliver the best results, and how to set it up without writing a single line of code.',
    readTime: '12 min read',
    date: 'Jun 19, 2026',
    featured: true,
    image: '/blog/whatsapp-automation-guide.png',
    imageAlt: 'The Ultimate Guide to WhatsApp Automation for Business 2026',
  },
  {
    slug: 'whatsapp-human-handoff',
    category: 'AI & Automation',
    title: 'WhatsApp AI Chatbot with Human Handoff: Complete Setup Guide (2026)',
    excerpt: 'The most effective WhatsApp support systems combine AI speed with human judgment. Configure seamless AI-to-human handoff so every conversation gets the right response at the right time.',
    readTime: '7 min read',
    date: 'Jun 10, 2026',
    featured: true,
    image: '/blog/whatsapp-human-handoff.png',
    imageAlt: 'WhatsApp AI Chatbot with Human Handoff: Setup Guide',
  },
  {
    slug: 'whatsapp-drip-sequence',
    category: 'WhatsApp',
    title: 'WhatsApp Drip Sequences: Automate Lead Nurturing and Follow-Ups (2026 Guide)',
    excerpt: 'A WhatsApp drip sequence sends the right message to every lead at the right time — automatically. Learn how to build, schedule, and optimize drip campaigns that convert.',
    readTime: '7 min read',
    date: 'Jun 5, 2026',
    featured: false,
    image: '/blog/whatsapp-drip-sequence.png',
    imageAlt: 'WhatsApp Drip Sequence: Automate Lead Nurturing and Follow-Ups',
  },
  {
    slug: 'whatsapp-lead-generation',
    category: 'Sales',
    title: 'WhatsApp Lead Generation: How to Capture, Qualify & Convert Leads on WhatsApp (2026)',
    excerpt: 'WhatsApp is where your customers already spend their time. Learn how to turn it into a full lead generation machine — from first click to qualified sales conversation — using automation that runs 24/7.',
    readTime: '9 min read',
    date: 'Jul 10, 2026',
    featured: true,
    image: '/blog/WhatsApp Lead Generation How to Capture, Qualify & Convert Leads on WhatsApp (2026).png',
    imageAlt: 'WhatsApp Lead Generation: Capture, Qualify and Convert Leads on WhatsApp',
  },
  {
    slug: 'whatsapp-api-pricing-2026',
    category: 'WhatsApp',
    title: 'WhatsApp Business API Pricing in 2026: Per-Message Cost Breakdown (Updated)',
    excerpt: 'Meta changed WhatsApp API billing from per-conversation to per-message in July 2025. If you are still calculating costs using the old model, this guide has the current breakdown.',
    readTime: '6 min read',
    date: 'Jul 8, 2026',
    featured: false,
    image: '/blog/WhatsApp Business API Pricing in 2026 Per-Message Cost Breakdown (Updated).png',
    imageAlt: 'WhatsApp Business API Pricing 2026: Per-Message Cost Breakdown',
  },
  {
    slug: 'whatsapp-cod-to-prepaid',
    category: 'E-Commerce',
    title: 'WhatsApp COD to Prepaid Conversion: Reduce RTO and Increase Revenue Automatically (2026)',
    excerpt: 'Converting COD orders to prepaid improves margins, reduces RTO risk, and eliminates courier remittance delays. A well-designed WhatsApp flow makes it happen automatically.',
    readTime: '7 min read',
    date: 'Jul 6, 2026',
    featured: false,
    image: '/blog/WhatsApp COD to Prepaid Conversion Reduce RTO and Increase Revenue Automatically (2026).png',
    imageAlt: 'WhatsApp COD to Prepaid Conversion: Automated Flow for E-Commerce',
  },
  {
    slug: 'whatsapp-cod-verification',
    category: 'E-Commerce',
    title: 'WhatsApp COD Verification for Shopify & WooCommerce: Complete Setup Guide (2026)',
    excerpt: 'Cash on delivery orders are the highest-risk shipments in e-commerce. WhatsApp COD verification confirms purchase intent before dispatch — reducing fake orders, RTOs, and wasted fulfillment costs.',
    readTime: '8 min read',
    date: 'Jul 10, 2026',
    featured: true,
    image: '/blog/WhatsApp COD Verification for Shopify & WooCommerce Complete Setup Guide (2026).png',
    imageAlt: 'WhatsApp COD Verification for Shopify and WooCommerce: Complete Setup Guide',
  },
  {
    slug: 'whatsapp-business-auto-reply',
    category: 'WhatsApp',
    title: 'WhatsApp Business Auto Reply: Set Up Out-of-Hours Messages That Convert (2026)',
    excerpt: 'A basic auto reply tells customers you are away. A smart one keeps them engaged, answers their question, and creates a path to the next step — even at 2am without a single agent online.',
    readTime: '5 min read',
    date: 'Jul 8, 2026',
    featured: false,
    image: '/blog/WhatsApp Business Auto Reply Set Up Out-of-Hours Messages That Convert (2026).png',
    imageAlt: 'WhatsApp Business Auto Reply: Set Up Out-of-Hours Messages That Convert',
  },
  {
    slug: 'whatsapp-re-engagement',
    category: 'WhatsApp',
    title: 'WhatsApp Re-Engagement Messages: Win Back Inactive Customers Automatically (2026)',
    excerpt: 'Most businesses focus on acquiring new leads while warm contacts go cold. A well-timed WhatsApp re-engagement sequence can recover dormant customers at a fraction of the cost of new acquisition.',
    readTime: '6 min read',
    date: 'Jul 7, 2026',
    featured: false,
    image: '/blog/WhatsApp Re-Engagement Messages Win Back Inactive Customers Automatically (2026).png',
    imageAlt: 'WhatsApp Re-Engagement Messages: Win Back Inactive Customers',
  },
  {
    slug: 'whatsapp-opt-in-message',
    category: 'WhatsApp',
    title: 'WhatsApp Opt-In Messages for Marketing: Templates, Rules & Compliance Guide (2026)',
    excerpt: 'Before you can send a single promotional WhatsApp message, your contact must have opted in. Learn what Meta actually requires, how to collect compliant opt-ins, and the exact templates that work.',
    readTime: '7 min read',
    date: 'Jul 5, 2026',
    featured: false,
    image: '/blog/WhatsApp Opt-In Messages for Marketing Templates, Rules & Compliance Guide (2026).png',
    imageAlt: 'WhatsApp Opt-In Messages for Marketing: Templates and Compliance Guide',
  },
  {
    slug: 'whatsapp-broadcast-limit',
    category: 'WhatsApp',
    title: 'WhatsApp Broadcast Limit: How to Send to More Than 256 Contacts (2026 Guide)',
    excerpt: 'The WhatsApp Business app caps broadcast lists at 256 contacts. If your customer list is larger — or growing — here is what you need to move beyond that limit without violating WhatsApp\'s policies.',
    readTime: '6 min read',
    date: 'Jul 3, 2026',
    featured: false,
    image: '/blog/WhatsApp Broadcast Limit How to Send to More Than 256 Contacts (2026 Guide).png',
    imageAlt: 'WhatsApp Broadcast Limit: How to Send to More Than 256 Contacts',
  },
  {
    slug: 'whatsapp-24-hour-window',
    category: 'WhatsApp',
    title: 'WhatsApp 24-Hour Messaging Window: What It Is and How to Build Drip Sequences Around It',
    excerpt: 'The 24-hour window is the most misunderstood rule in WhatsApp automation. Ignore it and your drip sequences silently break. Understand it and you can build campaigns that always deliver.',
    readTime: '7 min read',
    date: 'Jul 2, 2026',
    featured: false,
    image: '/blog/WhatsApp 24-Hour Messaging Window What It Is and How to Build Drip Sequences Around It.png',
    imageAlt: 'WhatsApp 24-Hour Messaging Window: How to Build Drip Sequences Around It',
  },
  {
    slug: 'whatsapp-abandoned-cart',
    category: 'E-Commerce',
    title: 'WhatsApp Abandoned Cart Recovery: Recover 35% More Orders Automatically (2026)',
    excerpt: 'Most abandoned carts stay abandoned because follow-ups are too slow or generic. WhatsApp automation sends instant, personalized messages that bring shoppers back to checkout.',
    readTime: '6 min read',
    date: 'Jun 1, 2026',
    featured: true,
    image: '/blog/whatsapp-abandoned-cart.png',
    imageAlt: 'WhatsApp Abandoned Cart Recovery for Shopify and WooCommerce',
  },
  {
    slug: 'shopify-whatsapp-bot',
    category: 'E-Commerce',
    title: 'Shopify WhatsApp Bot: Complete Setup Guide for 2026',
    excerpt: 'Set up a WhatsApp bot for your Shopify store in under 10 minutes. Automate order confirmations, COD verification, abandoned cart recovery, and 24/7 support.',
    readTime: '7 min read',
    date: 'May 1, 2026',
    featured: true,
    image: '/blog/shopify-whatsapp-bot.png',
    imageAlt: 'Shopify WhatsApp Bot: Complete Setup Guide for 2026',
  },
  {
    slug: 'reduce-cod-cancellations',
    category: 'E-Commerce',
    title: 'How to Reduce COD Cancellations by 60% with WhatsApp Automation',
    excerpt: 'Stop losing money on unverified COD shipments. WhatsApp order confirmation automation catches fake orders before dispatch and cuts cancellations dramatically.',
    readTime: '5 min read',
    date: 'Apr 28, 2026',
    featured: true,
    image: '/blog/reduce-cod-cancellations.png',
    imageAlt: 'How to Reduce COD Cancellations by 60% with WhatsApp Automation',
  },
  {
    slug: 'whatsapp-marketing-guide',
    category: 'Sales',
    title: 'WhatsApp Marketing Guide 2026: Strategy, Tools & Templates',
    excerpt: 'Everything you need to build a WhatsApp marketing strategy that grows sales. Covers broadcasts, automation, AI chatbots, segmentation, and message templates.',
    readTime: '9 min read',
    date: 'Apr 25, 2026',
    featured: false,
    image: '/blog/whatsapp-marketing-guide.png',
    imageAlt: 'WhatsApp Marketing Guide 2026: Strategy, Tools & Templates',
  },
  {
    slug: 'whatsapp-order-confirmation',
    category: 'E-Commerce',
    title: 'How to Automate WhatsApp Order Confirmations for Shopify',
    excerpt: 'Stop losing COD orders to silence. Learn how Zepliq\'s auto-confirmation flow reduces cancellations by up to 60% for Shopify stores.',
    readTime: '5 min read',
    date: 'Apr 14, 2026',
    featured: true,
    image: '/blog/whatsapp-order-confirmation.png',
    imageAlt: 'How to automate WhatsApp order confirmations for Shopify with Zepliq',
  },
  {
    slug: 'ai-chatbot-vs-human',
    category: 'AI & Automation',
    title: 'AI Chatbot vs Human Agent: When to Use Each (and How to Switch)',
    excerpt: 'The best businesses use both. Here\'s how to set up seamless AI-to-human handoff so no conversation falls through the cracks.',
    readTime: '6 min read',
    date: 'Apr 10, 2026',
    featured: true,
    image: '/blog/ai-chatbot-vs-human.png',
    imageAlt: 'AI Chatbot vs Human Agent: When to Use Each (and How to Switch)',
  },
  {
    slug: 'leadflow-pipeline-guide',
    category: 'Sales',
    title: 'The Complete Guide to Zepliq LeadFlow: Your AI Sales Pipeline',
    excerpt: 'From New Lead to Client in 6 stages. Here\'s how to set up LeadFlow, configure AI intent detection, and track your pipeline.',
    readTime: '8 min read',
    date: 'Apr 2, 2026',
    featured: false,
    image: '/blog/leadflow-pipeline-guide.png',
    imageAlt: 'The Complete Guide to Zepliq LeadFlow: Your AI Sales Pipeline',
  },
  {
    slug: 'woocommerce-whatsapp',
    category: 'E-Commerce',
    title: 'WooCommerce + WhatsApp: The Integration Every Store Needs in 2026',
    excerpt: 'Set up automatic order confirmations, follow-ups, and cancellations via WhatsApp in under 10 minutes.',
    readTime: '5 min read',
    date: 'Mar 28, 2026',
    featured: false,
    image: '/blog/woocommerce-whatsapp.png',
    imageAlt: 'WooCommerce + WhatsApp: The Integration Every Store Needs in 2026',
  },
  {
    slug: 'broadcast-campaigns-guide',
    category: 'WhatsApp',
    title: 'How to Send WhatsApp Broadcast Campaigns That Actually Get Read',
    excerpt: 'WhatsApp open rates are 98%. Here\'s how to segment your audience, time your messages, and write copy that converts.',
    readTime: '6 min read',
    date: 'Mar 22, 2026',
    featured: false,
    image: '/blog/broadcast-campaigns-guide.png',
    imageAlt: 'How to Send WhatsApp Broadcast Campaigns That Actually Get Read',
  },
  {
    slug: 'knowledge-base-tips',
    category: 'AI & Automation',
    title: '10 Things to Add to Your AI Knowledge Base Right Now',
    excerpt: 'The quality of your AI\'s answers depends entirely on what you train it on. Here\'s the complete checklist every business should use.',
    readTime: '4 min read',
    date: 'Mar 18, 2026',
    featured: false,
    image: '/blog/knowledge-base-tips.png',
    imageAlt: '10 Things to Add to Your AI Knowledge Base Right Now',
  },
  {
    slug: 'zepliq-v2-launch',
    category: 'Product Updates',
    title: 'Zepliq 2.0: LeadFlow Pipeline, WooCommerce Integration & More',
    excerpt: 'Our biggest release yet. Full CRM pipeline with AI stage detection, WooCommerce webhooks, and a redesigned dashboard.',
    readTime: '3 min read',
    date: 'Mar 10, 2026',
    featured: false,
    image: '/blog/zepliq-v2-launch.png',
    imageAlt: 'Zepliq 2.0: LeadFlow Pipeline, WooCommerce Integration & More',
  },
];

const CATEGORY_ICONS = {
  'WhatsApp':        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>,
  'E-Commerce':      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>,
  'AI & Automation': <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>,
  'Sales':           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
  'Product Updates': <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
};

export default function BlogPage() {
  const [active, setActive] = useState('All');
  const canvasRef = useRef(null);
  const animRef   = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let W, H, particles = [];
    const PARTICLE_COUNT = 55;
    const resize = () => { W = canvas.width = canvas.offsetWidth; H = canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);
    class Particle {
      constructor() { this.reset(); }
      reset() {
        this.x = Math.random() * W; this.y = Math.random() * H;
        this.r = Math.random() * 1.8 + 0.4;
        this.dx = (Math.random() - 0.5) * 0.25; this.dy = (Math.random() - 0.5) * 0.25;
        this.o = Math.random() * 0.5 + 0.15;
        this.hue = Math.random() > 0.6 ? 245 : 270;
      }
      update() { this.x += this.dx; this.y += this.dy; if (this.x < 0 || this.x > W || this.y < 0 || this.y > H) this.reset(); }
      draw() { ctx.beginPath(); ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2); ctx.fillStyle = `hsla(${this.hue}, 80%, 55%, ${this.o})`; ctx.fill(); }
    }
    for (let i = 0; i < PARTICLE_COUNT; i++) particles.push(new Particle());
    const drawLines = () => {
      for (let i = 0; i < particles.length; i++) for (let j = i + 1; j < particles.length; j++) {
        const dx = particles[i].x - particles[j].x, dy = particles[i].y - particles[j].y;
        const d = Math.sqrt(dx*dx + dy*dy);
        if (d < 100) { ctx.beginPath(); ctx.moveTo(particles[i].x, particles[i].y); ctx.lineTo(particles[j].x, particles[j].y); ctx.strokeStyle = `rgba(99,102,241,${0.06*(1-d/100)})`; ctx.lineWidth = 0.5; ctx.stroke(); }
      }
    };
    const animate = () => { ctx.clearRect(0,0,W,H); particles.forEach(p=>{p.update();p.draw();}); drawLines(); animRef.current = requestAnimationFrame(animate); };
    animate();
    return () => { window.removeEventListener('resize', resize); cancelAnimationFrame(animRef.current); };
  }, []);

  const filtered = active === 'All' ? POSTS : POSTS.filter(p => p.category === active);

  return (
    <div className="blog-page">
      <SEO
        title="Blog — WhatsApp Marketing Tips, Automation Guides & Business Growth"
        description="Read the Zepliq blog for expert WhatsApp marketing tips, AI chatbot guides, e-commerce automation strategies, and business growth insights. Stay ahead with the latest WhatsApp business news."
        keywords="WhatsApp marketing blog, WhatsApp automation tips, AI chatbot guide, WhatsApp business tips, ecommerce automation blog, WhatsApp sales strategy, chatbot marketing, WhatsApp growth hacks"
        canonical="/blog"
      />

      {/* ── HERO ── */}
      <section className="blog-hero">
        <canvas ref={canvasRef} className="blog-hero__canvas" aria-hidden="true" />
        <div className="blog-hero__blob blog-hero__blob--1" aria-hidden="true" />
        <div className="blog-hero__blob blog-hero__blob--2" aria-hidden="true" />
        <div className="container blog-hero__inner">
          <span className="badge badge-brand">Blog & Guides</span>
          <h1 className="display-xl blog-hero__title">
            Automate smarter.<br />
            <span className="gradient-text">Grow faster.</span>
          </h1>
          <p className="text-lg blog-hero__sub">
            Guides, tutorials, and product updates for businesses using Zepliq.
          </p>
        </div>
      </section>

      {/* ── CONTENT ── */}
      <section className="blog-main section">
        <div className="container">

          {/* Category filter */}
          <div className="blog-filters">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                className={`blog-filter ${active === cat ? 'blog-filter--active' : ''}`}
                onClick={() => setActive(cat)}
              >
                {CATEGORY_ICONS[cat] && <span className="blog-filter__icon">{CATEGORY_ICONS[cat]}</span>}
                {cat}
              </button>
            ))}
          </div>

          {/* Posts grid */}
          {filtered.length > 0 && (
            <div className="blog-grid">
              {filtered.map((post, index) => (
                <article key={post.slug} className={`blog-card blog-card--grid ${index % 2 !== 0 ? 'blog-card--alt' : ''}`}>
                  {post.image ? (
                    <Link to={`/blog/${post.slug}`} className="blog-card__img blog-card__img--sm blog-card__img--photo">
                      <img src={post.image} alt={post.imageAlt || post.title} loading="lazy" />
                    </Link>
                  ) : (
                    <div className="blog-card__img blog-card__img--sm blog-card__img--placeholder" aria-hidden="true">
                      <div className="blog-card__img-glow" />
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--brand-primary)', opacity: 0.35 }}>
                        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                      </svg>
                    </div>
                  )}
                  <div className="blog-card__body">
                    <div className="blog-card__meta">
                      <span className="blog-card__cat">
                        {CATEGORY_ICONS[post.category]}
                        {post.category}
                      </span>
                      <span className="blog-card__dot" />
                      <span className="blog-card__time">{post.readTime}</span>
                      <span className="blog-card__dot" />
                      <span className="blog-card__date">{post.date}</span>
                    </div>
                    <h3 className="blog-card__title blog-card__title--sm">
                      <Link to={`/blog/${post.slug}`} className="blog-card__title-link">
                        {post.title}
                      </Link>
                    </h3>
                    <p className="blog-card__excerpt blog-card__excerpt--sm">{post.excerpt}</p>
                    <Link to={`/blog/${post.slug}`} className="blog-card__read">
                      Read article
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}

          {filtered.length === 0 && (
            <div className="blog-empty">
              <p>No posts in this category yet. Check back soon.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
